import { PureComponent } from 'react';

import { MessageAudio } from '../messageAudio';

import fileFetch from './utils/fileFetch';

type MessageVoicemailProps = {
  recordingURL: string;
  date: number;
  conversation: any;
};

export default class MessageVoicemail extends PureComponent<MessageVoicemailProps> {
  constructor(props: MessageVoicemailProps) {
    super(props);
  }

  render() {
    const { recordingURL, ...otherProps } = this.props;

    if (!recordingURL) {
      return null;
    }

    const download = fileFetch(recordingURL, true);

    return (
      <MessageAudio
        {...otherProps}
        title="Voicemail"
        onDownload={() => {
          if (typeof download === 'function') {
            download();
          }
        }}
        soundfile={{
          src: fileFetch(recordingURL),
          type: 'audio/mp3',
        }}
      />
    );
  }
}
